import React from "react";
import classNames from "classnames";
import styles from "./UpdateProfile.module.css";
import Logo from "~/assets/common/BONVOY_LOGO_PrimaryReverse.png";
import { ArrowRightNoLineIcon } from "~/components/Icon/Icons/ArrowRightNoLineIcon";

export const UpdateProfile = () => {
  return (
    <section className={styles.box}>
      <div className={styles.logo}>
        <img src={Logo} alt="Marriott Logo" />
      </div>
      <div>
        <a
          href="https://www.marriott.com/loyalty/myAccount/profile.mi"
          className={classNames(styles.btn, "custom_click_track")}
          data-custom_click_track_value="Explore Page|Update Profile Button|internal"
        >
          Stay Plugged In <ArrowRightNoLineIcon />
        </a>
        <div>
          Update your profile so you receive the most relevant content and
          experiences for you.
        </div>
      </div>
    </section>
  );
};
